import * as React from 'react';
import { Tabs, Icon } from 'antd';
import { checkAddPermission } from '../../helper';
import { ExpenseService } from '../../../service/ExpenseService';
import { ExpenseEdges } from './constants';
import { AddExpense } from './AddExpense';
import { Table } from '../../common/Table';
import { UserService } from '../../../service/UserService';
import { UserNodeEdge } from '../../user/constants';

export class Expense extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      expenses: [],
      activeKey: '1',
      selectedExpense: null,
      user: null,
    };
  }

  expenseService = new ExpenseService();
  userService = new UserService();

  componentDidMount() {
    this.expenseService?.expense$.subscribe((expenses) =>
      this.setState({ expenses }),
    );
    this.userService?.user$.subscribe((user) =>
      this.setState({ user: user?.user }),
    );
  }

  handleTabChange = (activeKey: string) => {
    if (activeKey === '1') {
      this.setState({ activeKey, selectedExpense: null });
      return;
    }
    this.setState({ activeKey });
  };

  expenseColumn = () => [
    {
      title: 'Sl No',
      dataIndex: 'node.id',
      key: 'id',
      render: (text, obj, index) => <span>{index + 1}</span>,
    },
    {
      title: 'Head',
      dataIndex: 'node.head',
      key: 'head',
      render: (text, obj) => (
        <a
          onClick={() => {
            this.setState({ selectedExpense: obj, activeKey: '2' });
          }}
        >
          {text}
        </a>
      ),
      sortingValue: (text) => text,
    },
  ];

  render() {
    if (this.state.user && !checkAddPermission(this.state.user))
      return <h1>Access Denied</h1>;
    return (
      <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange}>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="table" />
              List Expense
            </span>
          }
          key="1"
          closable={false}
        >
          <Table
            dataSource={this.state.expenses}
            columns={this.expenseColumn()}
            rowKey={(record) => record.node.id || ''}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <span>
              <Icon type="plus" />
              Add Expense
            </span>
          }
          key="2"
        >
          <AddExpense
            expense={this.state.selectedExpense?.node}
            handleTabChange={this.handleTabChange}
          />
        </Tabs.TabPane>
      </Tabs>
    );
  }
}

interface State {
  expenses: ExpenseEdges[];
  activeKey: string;
  selectedExpense: ExpenseEdges | null;
  user?: UserNodeEdge | null;
}

interface Props {}
